import { render, staticRenderFns } from "./DeviceSettingsBodySection.vue?vue&type=template&id=e208b38c&scoped=true"
import script from "./DeviceSettingsBodySection.vue?vue&type=script&lang=js"
export * from "./DeviceSettingsBodySection.vue?vue&type=script&lang=js"
import style0 from "./DeviceSettingsBodySection.vue?vue&type=style&index=0&id=e208b38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e208b38c",
  null
  
)

export default component.exports